export default "__VITE_ASSET__Bn11gDQy__"